import { useSelector } from 'react-redux';
import { WalletHelper } from '@blink/components/src/utils';

import { Store } from '@/shared/store';

export const useWalletAddress = () => {
    const address = useSelector((state: Store) => state.wallets.active.address);
    const shortAddressName = WalletHelper.addressShortName(address);

    return { address, shortAddressName };
};
